module.exports = __webpack_public_path__ + "img/bannerly-poster.8707edc3.jpg";